import {
  AccountInformationProps,
  EmergencyInformationProps,
  ParentInformationProps,
  PasswordChangeProps,
  ProfileResponse,
  StudentInformationProps,
} from '../models/Profile';
import api from './index';

interface TokenProps {
  _token?: string;
}

const getMe = () => {
  return api.get(`/v4/profile/me`);
};

const getProfile = async () => {
  const { data } = await api.get<ProfileResponse>(`/v4/profile/student-profile`)
  return data
}

export interface PasswordChangeWithTokenProps extends PasswordChangeProps, TokenProps { }
const postPasswordChange = (props: PasswordChangeWithTokenProps) => {
  return api.post(`/v4/profile/passwordChange`, {
    old_password: props.old_password,
    new_password: props.new_password,
    new_password_confirmation: props.new_password_confirmation,
    _token: props._token,
  });
};

export interface StudentInformationWithTokenProps extends StudentInformationProps, TokenProps { }
const postStudentInformation = (props: StudentInformationWithTokenProps) => {
  return api.post(`/v4/profile/studentInformation`, {
    first_name: props.firstName,
    last_name: props.lastName,
    email: props.email,
    _token: props._token,
  });
};

export interface AccountInformationWithTokenProps extends AccountInformationProps, TokenProps { }
const postAccountInformation = (props: AccountInformationWithTokenProps) => {
  return api.post(`/v4/profile/accountInformation`, {
    username: props.username,
    timezone: props.timezone,
    language: props.language,
    _token: props._token,
  });
};

export interface ParentInformationWithTokenProps extends ParentInformationProps, TokenProps { }
const postParentInformation = (props: ParentInformationWithTokenProps) => {
  return api.post(`/v4/profile/parentInformation`, {
    first_name: props.firstName,
    last_name: props.lastName,
    email: props.email,
    _token: props._token,
  });
};

export interface EmergencyInformationWithTokenProps extends EmergencyInformationProps, TokenProps { }
const postEmergencyInformation = (props: EmergencyInformationWithTokenProps) => {
  return api.post(`/v4/profile/emergencyInformation`, {
    address: props.address,
    city: props.city,
    contact: props.contact,
    contact_phone: props.contactPhone,
    contact_relationship: props.contactRelationship,
    country: props.country,
    state: props.state,
    zip_code: props.zipCode,
    _token: props._token,
  });
};

const postEnablePlay2LearnClasses = () => {
  return api.post(`/v4/profile/P2L_class_enable`);
};

interface TodayResponse {
  today: string;
}
const getToday = async () => {
  const { data } = await api.get<TodayResponse>(`/v4/today`);
  return data;
};

export const ProfileService = {
  getMe,
  postAccountInformation,
  postEmergencyInformation,
  postParentInformation,
  postPasswordChange,
  postStudentInformation,
  postEnablePlay2LearnClasses,
  getProfile,
  getToday,
};
